import React from 'react';
import { componentName } from "../../const";
import { Placeholder } from "../placeholder";
import { AppView, PageView } from "./c";
export default function PrototypeView(props) {
  var pageSelect = props.pageSelect;
  var _ref = pageSelect || {},
    app = _ref.app,
    page = _ref.page,
    version = _ref.version;
  var _ref2 = app || {},
    appCode = _ref2.appCode;
  var appNode = /*#__PURE__*/React.createElement(AppView, {
    app: app,
    showEmptyHint: true
  });
  if (!appCode) {
    return appNode;
  }
  var pageNode = /*#__PURE__*/React.createElement(PageView, {
    app: app,
    page: page,
    version: version,
    showEmptyHint: true,
    before: "\u5D4C\u5165\u7684\u9875\u9762",
    after: /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 12,
        color: 'rgba(0,0,0,.6)',
        marginTop: 4
      }
    }, "\u8BF7\u4F7F\u7528\u9884\u89C8\u67E5\u770B\u6548\u679C")
  });
  return /*#__PURE__*/React.createElement(Placeholder, null, pageNode);
}
PrototypeView.displayName = componentName;